import React from 'react';
import './index.css';
import App from './App';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import WeaponScreen from "./builder/WeaponScreen";
import LoadoutCard from "./builder/share/LoadoutCard";
import AboutPage from "./pages/AboutPage";
import FeaturedPage from "./pages/FeaturedPage";
import ErrorPage from "./pages/ErrorPage";
import MetaPage from "./pages/MetaPage";
import AuthHandler from "./auth/AuthHandler";
import ProfilePage from "./pages/profile/ProfilePage";
import ProfilePreview from "./pages/profile/ProfilePreview";
import RedeemCodePage from "./pages/RedeemCodePage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        children: [
            {
                path: "",
                element: <WeaponScreen/>
            },
            {
                path: "about",
                element: <AboutPage/>
            },
            {
                path: "redeem-code",
                element: <RedeemCodePage/>
            },
            {
                path: "featured",
                element: <FeaturedPage/>
            },
            {
                path: "meta",
                element: <MetaPage/>
            },
            {
                path: "meta/:metaWeapon",
                element: <MetaPage/>
            },
            {
                path: "loadouts/:loadoutId",
                element: <WeaponScreen/>
            },
            {
                path: "profile/:userId",
                element: <ProfilePage/>
            },
            {
                path: "oauth/discord",
                element: <AuthHandler/>
            },
            {
                path: "*",
                element: <ErrorPage/>
            }
        ]
    },
    {
        path: "/loadouts/:loadoutId/card",
        element: <LoadoutCard/>
    },
    {
        path: "profile/:userId/preview",
        element: <ProfilePreview/>
    },
])

const Routes = () => <RouterProvider router={router}/>

export default Routes